// Single admin rule shared across the frontend (mirrors backend/src/lib/admin-access.js).
// Admins get permanent full access regardless of subscription plan or planFeatures.
export const isAdmin = (user) => user?.role === "ADMIN";
export const isSupport = (user) => user?.role === "SUPPORT";
// Staff = Admin or Support with access switched on. Display only — the server enforces it.
// AI Scene Studio access — mirrors canAccessSceneStudio in backend/src/lib/admin-access.js (temporarily Admins only).
export const canAccessSceneStudio = (user) => isAdmin(user) && user?.staffActive !== false;
export const isStaff = (user) => (isAdmin(user) || isSupport(user)) && user?.staffActive !== false;

const ADMIN_PLAN_FEATURES = {
  canCreateDocument: true,
  canDeleteDocument: true,
  canEditDocument: true,
  canExportDocument: true,
  canImportDocument: true,
  canCollaborate: true,
  canUseSceneBreakdown: true,
  canUseCharacterBreakdown: true,
  canListScenes: true,
  canListCharacters: true,
  canGetDocumentRevisions: true,
  canApplyRevision: true,
  canUseCategoriesAndElements: true,
  createDocumentLimit: Infinity,
};

// TEMPORARY university trial access: every signed-in user gets the full standard
// feature set until pricing/plans are added. Admins are covered by the same set;
// admin-only areas are gated separately by isAdmin. Revert to planFeatures when
// subscriptions return.
export const getPlanFeatures = (user) => {
  const features=isAdmin(user) || Boolean(user?._id || user?.id) ? ADMIN_PLAN_FEATURES : user?.planFeatures;
  if(isAdmin(user)||user?.subscriptionAccess?.enrolled!==true||user.subscriptionAccess.canEdit===true)return features;
  return {...features,canCreateDocument:false,canDeleteDocument:false,canEditDocument:false,canImportDocument:false,
    canCollaborate:false,canUseSceneBreakdown:false,canUseCharacterBreakdown:false,canApplyRevision:false,canUseCategoriesAndElements:false};
};

// Screenwriting (the editor): during the current testing stage every signed-in user
// may use it; sign-in itself is enforced by ProtectedRoute. Plan limits come later.
export const canAccessScreenwriting = (user) =>
  isAdmin(user) || Boolean(user?._id || user?.id);
